export default "data:image/gif;base64,R0lGODlhCwAKAKEBAAAA/////////////yH5BAEAAAIALAAAAAALAAoAAAIVlI+pCmsAHWwMhIjmxW/O422YRwoFADs="